const DEFAULT_BARCODE_OPTIONS = {
  format: "CODE128",
  displayValue: false,
  margin: 8,
  height: 82,
  width: 2,
};

const generateBarcodeDataUrl = async (value, options = {}) => {
  const barcodeValue = typeof value === "string" ? value : `${value ?? ""}`;
  const { default: JsBarcode } = await import("jsbarcode");
  const canvas = document.createElement("canvas");
  JsBarcode(canvas, barcodeValue, { ...DEFAULT_BARCODE_OPTIONS, ...options });
  return canvas.toDataURL("image/png");
};

export { DEFAULT_BARCODE_OPTIONS, generateBarcodeDataUrl };
